import { apiClient } from './client'
import { getCurrentServiceStatusMetadata } from '../serviceStatus'

export type DeploymentStatusColor = 'Red' | 'Green' | 'Blue'

export type DeploymentStatusService = {
  id: string
  label: string
  url: string
  state: DeploymentStatusColor
  commitSha?: string | null
  branch?: string | null
  commitSource?: string | null
  buildTimeUtc?: string | null
  checkedAtUtc: string
  message?: string | null
}

export type DeploymentStatusEnvironment = {
  id: string
  label: string
  referenceCommitSha?: string | null
  services: DeploymentStatusService[]
}

export type DeploymentStatusResponse = {
  checkedAtUtc: string
  environments: DeploymentStatusEnvironment[]
}

export async function getDeploymentStatus() {
  const metadata = await getCurrentServiceStatusMetadata()
  const { data } = await apiClient.get<DeploymentStatusResponse>('/api/admin/platform/status', {
    headers: metadata ? {
      'X-Service-Id': metadata.serviceId,
      'X-Service-Name': metadata.serviceName,
      'X-Service-Commit-Sha': metadata.commitSha ?? '',
      'X-Service-Branch': metadata.branch ?? '',
      'X-Service-Commit-Source': metadata.commitSource ?? '',
      'X-Service-Build-Time-Utc': metadata.buildTimeUtc ?? ''
    } : undefined
  })
  return data
}
